import {Component, OnInit, forwardRef, Input, Output, EventEmitter, HostListener} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LfsaSelectOptIspComponent),
  multi: true
};
@Component({
  selector: 'app-lfsa-select-opt-isp',
  templateUrl: './lfsa-select-opt-isp.component.html',
  styleUrls: ['./lfsa-select-opt-isp.component.css'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class LfsaSelectOptIspComponent implements ControlValueAccessor {

  @Input() comboBox: any[];
  @Input() label: string;
  @Input() isReadOnly = false;
  @Input() id: string;
  @Input() opcion: string;
  @Input() idOpcion: string;
  @Input() habilitar: boolean;
  @Input() control: any;
  @Input() claseLabel = '';
  @Input() clearContenido: boolean;

  @Input() mostrarImg = false;
  @Input() rutaImagen: string = '';
  @Output() update: EventEmitter<any> = new EventEmitter();

  private innerValue: any;
  @Input() model;

/*  @HostListener('click', ['$event']) openDropdown($event: MouseEvent) {
    const input: HTMLInputElement = <HTMLInputElement>$event.target;
    // without timeout it don't always fetch new data on click
    setTimeout(() => input.dispatchEvent(new Event('input')), 0);
  }*/
  constructor() { }

  ngOnInit(): void {
  }

  get value() {
    //console.log('getmodel->',this.model);
    return this.model;
  }

  set value(v: any) {
   // console.log(new Error().stack);
    if (v !== this.model) {
      this.model = v;
      this.modelChanged(v);
      console.log('setvalue->', v, this.model);
    }
  }

  onChangeCb: (_: any) => void = () => {
    console.log("--asasas-----");
  };
  onTouchedCb: (_: any) => void = () => {
  };

  writeValue(v: any): void {
    this.value = v;
  }

  registerOnChange(fn: any): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isReadOnly = isDisabled;
  }
  modelChanged(_: any) {
    //console.log("model->",this.model);
    //console.log("param->",_);
    this.update.emit(this.model);
  }

}

